module.exports = __webpack_public_path__ + "img/Kazan-bg.fe50a613.jpg";